import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LogoStrip from "./components/LogoStrip";
import Benefits from "./components/Benefits";
import ValueProps from "./components/ValueProps";
import Showcase from "./components/Showcase";
import Industries from "./components/Industries";
import Steps from "./components/Steps";
import Stats from "./components/Stats";
import GetStarted from "./components/GetStarted";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";

export default function Home() {
  useScrollReveal();

  return (
    <div className="relative min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Benefits />
        <ValueProps />
        <GetStarted />
        <Steps />
        <Showcase />
        <Industries />
        <LogoStrip />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}